module.exports = __webpack_public_path__ + "static/img/Galanz@2x.765b343f.png";